/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots9Icon24Solid = forwardRef('UiMenuDots9Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M19.502 6.747a2.248 2.248 0 1 0 0-4.497 2.248 2.248 0 0 0 0 4.497Z" }),
        React.createElement("path", { d: "M21.75 12a2.248 2.248 0 1 1-4.497 0 2.248 2.248 0 0 1 4.497 0Z" }),
        React.createElement("path", { d: "M4.502 21.747a2.248 2.248 0 1 0 0-4.497 2.248 2.248 0 0 0 0 4.497Z" }),
        React.createElement("path", { d: "M14.248 19.498a2.248 2.248 0 1 1-4.497 0 2.248 2.248 0 0 1 4.497 0Z" }),
        React.createElement("path", { d: "M21.75 19.498a2.248 2.248 0 1 1-4.497 0 2.248 2.248 0 0 1 4.497 0Z" }),
        React.createElement("path", { d: "M12 14.248a2.248 2.248 0 1 0 0-4.497 2.248 2.248 0 0 0 0 4.497Z" }),
        React.createElement("path", { d: "M6.75 12a2.248 2.248 0 1 1-4.497 0 2.248 2.248 0 0 1 4.497 0Z" }),
        React.createElement("path", { d: "M14.248 4.498a2.248 2.248 0 1 1-4.497 0 2.248 2.248 0 0 1 4.497 0Z" }),
        React.createElement("path", { d: "M4.502 6.747a2.248 2.248 0 1 0 0-4.497 2.248 2.248 0 0 0 0 4.497Z" })));
});
